
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study/[country_name]/university/[university_name]/courses",
      function () {
        return require("private-next-pages/study/[country_name]/university/[university_name]/courses/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study/[country_name]/university/[university_name]/courses"])
      });
    }
  